import React from "react";
import { motion } from "framer-motion";
import "../../css/dashboard/statsCard.css";
import { useNavigate } from "react-router-dom";

function formatAmount(val) {
  const n = typeof val === "string" ? parseFloat(val.replace(/[^0-9.]/g, "")) : Number(val);
  if (isNaN(n) || n === 0) return "₹0";
  if (n >= 10_000_000) return `₹${parseFloat((n / 10_000_000).toFixed(2))} Cr`;
  if (n >= 100_000)    return `₹${parseFloat((n / 100_000).toFixed(2))} L`;
  if (n >= 1_000)      return `₹${parseFloat((n / 1_000).toFixed(1))} K`;
  return `₹${n.toLocaleString("en-IN")}`;
}

function isZeroValue(value) {
  if (typeof value === "number") return value === 0;
  const n = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  return !isNaN(n) && n === 0;
}

export default function StatsCard({
  title,
  value,
  subtitle,
  icon: Icon,
  color = "blue",
  to,
  formatCurrency = false,
}) {
  const navigate = useNavigate();
  const displayValue = formatCurrency ? formatAmount(value) : value;
  const isZero = isZeroValue(value);

  return (
    <motion.div
      className={`stats-card ${color}${isZero ? " zero-alert" : ""}`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      onClick={() => to && navigate(to)}
      style={{ cursor: to ? "pointer" : "default" }}
    >
      <div className="stats-card-content">
        <div className="stats-text">
          <p className="stats-title">{title}</p>
          <p className="stats-value">{displayValue}</p>
          <p className="stats-subtitle">{subtitle}</p>
        </div>
        <div className={`stats-icon ${isZero ? "zero-alert-icon" : color}`}>
          <Icon size={22} />
        </div>
      </div>
    </motion.div>
  );
}
